var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71436 12.0001C1.71436 6.32236 6.32236 1.71436 12.0001 1.71436C17.6778 1.71436 22.2858 6.32236 22.2858 12.0001C22.2858 17.6778 17.6778 22.2858 12.0001 22.2858C6.32236 22.2858 1.71436 17.6778 1.71436 12.0001ZM16.1935 7.56128L17.7795 9.15848L10.5001 16.4379L6.21973 12.1575L7.80719 10.5701L10.4997 13.2551L16.1935 7.56128Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.dbe39ea9.svg";
export { ForwardRef as ReactComponent };